export class ExistingAccountLoginResult {
  applyingForANewLoan: boolean = false;
  userForgotPassword: boolean = false;
  authToken: string | undefined = undefined;
  refreshToken: string | undefined = undefined;
  appId?: number | undefined = undefined;
}
